// Generated from src/assets/Check.svg
import React, { PureComponent } from "react";

interface ISVGMeasurementToolIconProps {
  /**
   * additional classname
   */
  // prettier-ignore
  className?: string;
  /**
   * size of the svg icon
   */
  // prettier-ignore
  size?: string | number;
  /**
   * color of the svg icon
   */
  // prettier-ignore
  fill?: string;
  /**
   * onClick event
   */
  // prettier-ignore
  onClick?: React.MouseEventHandler<SVGSVGElement>;
}

const style = {
  display: "block",
  flex: "0 0 auto",
  cursor: "pointer"
};

export default class SVGMeasurementToolIcon extends PureComponent<
  ISVGMeasurementToolIconProps,
  {}
> {
  render() {
    const props = this.props;
    const { size, fill } = props;
    return (
      <svg
        {...props}
        fontSize={size || 32}
        fill={fill || "currentColor"}
        style={style}
        x="0px"
        y="0px"
        width="35px"
        height="35px"
        viewBox="0 0 35 35"
        enableBackground="new 0 0 35 35"
      >
        <g>
          <path
            fill="#FFFFFF"
            d="M34,1v33H22.188V1H34 M35,0H21.188v35H35V0L35,0z"
          />
        </g>
        <g>
          <path
            fill="#FFFFFF"
            d="M19.25,1v33H1.063V1H19.25 M20.25,0H0.063v35H20.25V0L20.25,0z"
          />
        </g>
        <rect x="23.5" y="4" fill="#FFFFFF" width="9.125" height="2.625" />
        <rect
          x="23.531"
          y="9.938"
          fill="#FFFFFF"
          width="9.125"
          height="2.625"
        />
        <rect
          x="23.563"
          y="15.875"
          fill="#FFFFFF"
          width="9.125"
          height="2.625"
        />
        <rect
          x="23.594"
          y="21.813"
          fill="#FFFFFF"
          width="9.125"
          height="2.625"
        />
        <rect
          x="23.625"
          y="27.75"
          fill="#FFFFFF"
          width="9.125"
          height="2.625"
        />
      </svg>
    );
  }
}
